export default class InfoDistributionActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_INFODISTRIBUTION='GET_HELPER_INFODISTRIBUTION';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: InfoDistributionActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: InfoDistributionActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: InfoDistributionActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: InfoDistributionActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: InfoDistributionActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: InfoDistributionActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: InfoDistributionActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: InfoDistributionActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: InfoDistributionActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: InfoDistributionActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: InfoDistributionActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: InfoDistributionActions.GET_HELPER_BRANCH,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: InfoDistributionActions.ERROR_SERVER,
      payload: error
    };
  }
}